import { render, staticRenderFns } from "./InputFormItem.vue?vue&type=template&id=e886e380&"
import script from "./InputFormItem.vue?vue&type=script&lang=js&"
export * from "./InputFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports